<template>
  <div class="form-row">
    <div class="table-responsive col">
      <table class="table table-bordered">
        <tr>
          <th colspan="2">
            <input
              type="checkbox"
              :true-value="1"
              :false-value="0"
              v-model="always"
              class="mr-2"
              @change="updateAlways"
            />Sempre
          </th>
          <th v-for="(day,i) in weekDays" :key=" 'dayMask' + i">
            <input
              type="checkbox"
              v-model="dayMask[i]"
              :true-value="1"
              :false-value="0"
              @change="updateDay"
            />
            {{ day }}
          </th>
        </tr>
      </table>
    </div>
  </div>
</template>
<style lang="scss" scoped>
  .table-responsive {
    border: none !important;
  }
</style>
<script>
  export default {
    components: {},
    data() {
      return {
        update: false,
        dayMask: [0, 0, 0, 0, 0, 0, 0],
        always: false,
        weekDays: ["lun", "mar", "mer", "gio", "ven", "sab", "dom"],
      };
    },
    props: ["value"],
    computed: {},
    watch: {
    value(v2, v1) {
      this.parse();
    }
  },
    methods: {
      updateAlways: function() {
        let self = this;

          for (var d = 0; d < 7; d++) {
              self.dayMask[d] = self.always ? 1 :0;
          }
          self.$emit("change", self.dayMask);

      },
      updateDay: function() {
        let self = this;
          let conto = 0;
          for (var d = 0; d < 7; d++) {
            conto += self.dayMask[d];
          }
          self.always = conto == 7 ? 1 : 0;

        self.$emit("change", self.dayMask);
      },
      parse: function(){this.dayMask = JSON.parse( JSON.stringify(this.value));
      let self = this;
          let conto = 0;
          for (var d = 0; d < 7; d++) {
            conto += self.dayMask[d];
          }
          self.always = conto == 7 ? 1 : 0;
    }



    },

    mounted() {
      this.parse();
    }
  };
</script>
